import { ReactComponent as RiyalSm } from "../../../../assets/images/svg/twoPartyContract/riyal-sm.svg";
import { ReactComponent as RiyalSmDark } from "../../../../assets/images/svg/twoPartyContract/riyal-sm-dark.svg";
import { ReactComponent as RiyalMd } from "../../../../assets/images/svg/twoPartyContract/riyal-md.svg";

/**
 * The Saudi riyal sign as the design draws it: small grey-black beside a fee, small black in
 * the success summary, larger blue beside the net amount.
 */
const Riyal = ({ variant }: { variant: "sm" | "smDark" | "md" }) => {
  if (variant === "md") return <RiyalMd aria-hidden />;
  if (variant === "smDark") return <RiyalSmDark aria-hidden />;
  return <RiyalSm aria-hidden />;
};

export default Riyal;
